import React from "react";

const OurFaqs = () => {
  return (
    <div className="our-faqs bg-section pb-md-4">
      <div className="container">
        <div className="row align-items-center">
          {/* Image Column */}
          <div className="col-lg-6 order-lg-1 order-md-2 order-2 d-none d-md-block">
            <div className="our-faqs-image">
              <div className="faqs-img-1">
                <figure className="image-anime">
                  {/* <img src="images/our-faqs-img-1.jpg" alt="Aaryan Travels Vehicle" /> */}
                </figure>
              </div>

              <div className="faqs-img-2">
                <figure className="image-anime">
                  {/* <img src="images/our-faqs-img-2.jpg" alt="Corporate Travel Service" /> */}
                </figure>
              </div>
            </div>
          </div>

          {/* FAQ Content Column */}
          <div className="col-lg-6 order-lg-2 order-md-1 order-1">
            <div className="our-faqs-content">
              {/* Section Title */}
              <div className="section-title">
                <h3 className="wow fadeInUp">frequently asked questions</h3>
                <h2 className="text-anime-style-3" data-cursor="-opaque">
                  Everything you need to know about Aaryan Travels
                </h2>
              </div>

              {/* FAQ Accordion */}
              <div className="our-faqs-accordion" id="faqsaccordion">
                {/* FAQ Item 1 */}
                <div className="accordion-item wow fadeInUp" data-wow-delay="0.25s">
                  <h2 className="accordion-header" id="faqheading1">
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faqcollapse1"
                      aria-expanded="true"
                      aria-controls="faqcollapse1"
                    >
                      What services does Aaryan Travels provide?
                    </button>
                  </h2>
                  <div
                    id="faqcollapse1"
                    className="accordion-collapse collapse show"
                    aria-labelledby="faqheading1"
                    data-bs-parent="#faqsaccordion"
                  >
                    <div className="accordion-body">
                      <p>
                        Aaryan Travels specializes in premium travel solutions including 
                        corporate transportation, airport pick-up and drop services, 
                        outstation travel, and customized all-India trips. 
                        Whether for business or leisure, we ensure safe, reliable, and 
                        punctual rides across India.
                      </p>
                    </div>
                  </div>
                </div>

                {/* FAQ Item 2 */}
                <div className="accordion-item wow fadeInUp" data-wow-delay="0.5s">
                  <h2 className="accordion-header" id="faqheading2">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faqcollapse2"
                      aria-expanded="false"
                      aria-controls="faqcollapse2"
                    >
                      Do you offer airport transfers and corporate packages?
                    </button>
                  </h2>
                  <div
                    id="faqcollapse2"
                    className="accordion-collapse collapse"
                    aria-labelledby="faqheading2"
                    data-bs-parent="#faqsaccordion"
                  >
                    <div className="accordion-body">
                      <p>
                        Yes, we specialize in both! Our airport transfer service ensures 
                        timely pick-up and drop-off with real-time flight tracking. 
                        For businesses, we offer dedicated corporate packages with 
                        monthly billing, professional chauffeurs, and flexible scheduling.
                      </p>
                    </div>
                  </div>
                </div>

                {/* FAQ Item 3 */}
                <div className="accordion-item wow fadeInUp" data-wow-delay="0.75s">
                  <h2 className="accordion-header" id="faqheading3">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faqcollapse3"
                      aria-expanded="false"
                      aria-controls="faqcollapse3"
                    >
                      Can I book a ride for travel across India?
                    </button>
                  </h2>
                  <div
                    id="faqcollapse3"
                    className="accordion-collapse collapse"
                    aria-labelledby="faqheading3"
                    data-bs-parent="#faqsaccordion"
                  >
                    <div className="accordion-body">
                      <p>
                        Absolutely! Aaryan Travels offers pan-India service, allowing 
                        you to book cars for intercity or long-distance journeys anywhere 
                        in the country. Whether it’s a one-way drop, round trip, or 
                        multi-city itinerary, we provide clean vehicles, expert drivers, 
                        and full travel support.
                      </p>
                    </div>
                  </div>
                </div>

                {/* FAQ Item 4 */}
                <div className="accordion-item wow fadeInUp" data-wow-delay="1s">
                  <h2 className="accordion-header" id="faqheading4">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faqcollapse4"
                      aria-expanded="false"
                      aria-controls="faqcollapse4"
                    >
                      How can I book a car with Aaryan Travels?
                    </button>
                  </h2>
                  <div
                    id="faqcollapse4"
                    className="accordion-collapse collapse"
                    aria-labelledby="faqheading4"
                    data-bs-parent="#faqsaccordion"
                  >
                    <div className="accordion-body">
                      <p>
                        You can easily book through our website, WhatsApp, or by calling 
                        our 24×7 support line. Share your trip details, and our team 
                        will confirm your booking instantly with transparent pricing 
                        and no hidden charges.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* FAQ Accordion End */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurFaqs;
